import { __assign, __rest } from "tslib";
import React from 'react';
import { FlexBox } from './FlexBox';
export var FlexColumn = function (_a) {
    var children = _a.children, other = __rest(_a, ["children"]);
    return (React.createElement(FlexBox, __assign({ flexDirection: "column", justifyContent: "flex-end" }, other), children));
};
//# sourceMappingURL=FlexColumn.js.map